import script from "./SectionList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionList.vue?vue&type=script&setup=true&lang=ts"

import "./SectionList.vue?vue&type=style&index=0&id=380308f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-380308f1"]])

export default __exports__